import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';

export const InputContainer = styled.label`
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  border-radius: 16px;
  border: 1px solid var(--border-main);
  background: var(--bg-main);
  padding: 12px 15px;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const Input = styled.input<{
  $isActive: boolean;
  $width: string;
}>`
  border: none;
  font-size: 16px;
  background: transparent;
  outline: none;
  appearance: textfield;
  -moz-appearance: textfield;
  transition: border-color 0.3s;
  width: ${({ $width }) => $width};
  min-width: 1.1ch;
  color: ${({ $isActive }) =>
    $isActive ? 'var(--textAndLabels-main)' : 'var(--textAndLabels-tertiary)'};
  will-change: width;
  caret-color: var(--textAndLabels-dark);

  &::placeholder {
    color: var(--textAndLabels-tertiary);
    opacity: 1;
  }
`;

export const Label = styled(Typography).attrs({ variant: 'body2' })`
  margin-right: 5px;
  color: var(--textAndLabels-main);
`;

export const CurrencyWrapper = styled.div<{
  $isActive: boolean;
}>`
  color: ${({ $isActive }) =>
    $isActive ? 'var(--textAndLabels-main)' : 'var(--textAndLabels-tertiary)'};
`;
